import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  name: string;
  price?: string | React.ReactElement;
  originalPrice?: string | React.ReactElement;
  badge?: React.ReactNode;
  year?: string;
  showPrices?: boolean;
  wrap?: boolean;
  align?: "left" | "center";
  layout?: "horizontal" | "vertical";
}

const ProductTitle = ({
  classNames,
  name,
  price = "",
  originalPrice,
  badge,
  year,
  showPrices = true,
  align = "center",
  wrap = false,
  layout = "horizontal"
}: Props) => (
  <h1
    className={cn(
      "ProductTitle", //
      [{ wrap, [`align-${align}`]: align, [`layout-${layout}`]: layout }],
      classNames
    )}
  >
    {/* Wrapper needed to isolate container-type from parent flex contexts */}
    <span className="ProductTitle__container">
      <span className="ProductTitle__nameAndYear">
        <span className="ProductTitle__name">{name}</span>
        {year && (
          <>
            {
              // Icon separator is only shown in two-lines layout to separate name and year visually;
              // in three-lines layout, the separation is handled by line breaks and a different color for the year
              name && layout === "horizontal" && <span className="ProductTitle__icon" />
            }
            <span className="ProductTitle__year">{year}</span>
          </>
        )}
      </span>

      {showPrices && (
        <div className="ProductTitle__priceAndBadge">
          <span className="ProductTitle__priceAndOriginalPrice">
            {!!price && <span className="ProductTitle__price">{price}</span>}
            {!!originalPrice && <span className="ProductTitle__originalPrice">{originalPrice}</span>}
          </span>
          {badge && <span className="ProductTitle__badge">{badge}</span>}
        </div>
      )}
    </span>
  </h1>
);

export default ProductTitle;
